/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../utils/cn';

import style from './Switch.module.css';

const Switch = ({
  className, name, size, value, onChange, label, checkedColor,
}) => (
  <div className={cn([className, style.switch])}>
    <div className={style.wrapper}>
      <input
        className={style.input}
        name={name}
        id={name}
        type="checkbox"
        checked={value}
        onChange={onChange}
      />
      <label className={cn([style.label, style[size], style[checkedColor]])} htmlFor={name} />
    </div>
    {label
      ? (
        <div className={cn([style.text, style[size]])}>
          {label}
        </div>
      )
      : null}
  </div>

);

Switch.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  checkedColor: PropTypes.oneOf(['primary', 'secondary', 'accent', 'success', 'error', 'warning', 'grey']),
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.string,
};

Switch.defaultProps = {
  label: null,
  checkedColor: 'success',
  size: 'medium',
  className: null,
};

export default Switch;
